export default __webpack_public_path__ + "static/media/defaultVideoImg.c364f85a.png";